package tta.destinigo.talktoastro.core.navigation_decompose.root_component

import co.touchlab.kermit.Logger
import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.ExperimentalDecomposeApi
import com.arkivanov.decompose.router.slot.ChildSlot
import com.arkivanov.decompose.router.slot.activate
import com.arkivanov.decompose.router.slot.childSlot
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.stack.backStack
import com.arkivanov.decompose.router.stack.childStack
import com.arkivanov.decompose.router.stack.pop
import com.arkivanov.decompose.router.stack.popTo
import com.arkivanov.decompose.router.stack.webhistory.WebHistoryController
import com.arkivanov.decompose.value.Value
import org.koin.core.component.KoinComponent
import tta.destinigo.talktoastro.core.navigation_decompose.NavigationChild
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.DialogConfiguration
import tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller.DeepLink
import tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller.NavigationStackFactory

class DefaultRootComponent @OptIn(
    ExperimentalDecomposeApi::class,
    ExperimentalDecomposeApi::class
) constructor(
    private val componentContext: ComponentContext,
    private val deepLink: DeepLink.Web,
    private val webHistoryController: WebHistoryController? = null,
) : RootComponent, ComponentContext by componentContext,KoinComponent {

    private val childConfig = NavigationChild
    private val navigationStackFactory = NavigationStackFactory

    @OptIn(ExperimentalDecomposeApi::class)
    private val _stack =
        childStack(
            source = NavigationChild.navigation,
            serializer = Configuration.serializer(),
            initialStack = {
                navigationStackFactory.getInitialStack(
                    webHistoryPaths = webHistoryController?.historyPaths,
                    deepLink = deepLink
                )
            },
            childFactory = childConfig::createChild,
            handleBackButton = true
        )

    private val _dialog = childSlot(
        source = NavigationChild.dialogNavigation,
        serializer = DialogConfiguration.serializer(), // Or null if state saving is not needed
        handleBackButton = true, // Close dialog on back press
        key = "HomeDialog",      // Unique key
        childFactory = childConfig::createDialogChild
    )


    override val stack: Value<ChildStack<*, RootComponent.Child>> = _stack
    override val dialog: Value<ChildSlot<*, RootComponent.DialogChild>> = _dialog

    init{
        windowHistoryController()
    }

    @OptIn(ExperimentalDecomposeApi::class)
    fun windowHistoryController()=webHistoryController?.attach(
        navigator = NavigationChild.navigation,
        serializer = Configuration.serializer(),
        stack = _stack,
        getPath = {navigationStackFactory.getPathForConfig(it)},
        getConfiguration = {navigationStackFactory.getConfigForPath(it)},
        onWebNavigation = { _, _ -> true }
    )

    fun onAndroidBackClick(onExit: () -> Unit) {
        if (_stack.backStack.isEmpty()) {
//            val selectedIndex = _bottomNavigation.value.selectedIndex
            // If already on the Home tab (index 0), show exit confirmation
            NavigationChild.dialogNavigation.activate(
                DialogConfiguration.ExitDialogConfig {
                    Logger.d("Exit confirmed")
                    onExit.invoke()
                }
            )
        } else {
            // Otherwise, pop from navigation stack
            Logger.d("Back stack is not empty, popping navigation stack")
            NavigationChild.navigation.pop()
        }
    }

    override fun onBackClicked() {
        NavigationChild.navigation.pop()
    }

    override fun onBackClicked(toIndex: Int) {
        NavigationChild.navigation.popTo(index = toIndex)
    }

    override fun selectTab(index: Int) {
    }
}


